/**
 * @ Author: Your name
 * @ Create Time: 2020-05-20 18:29:44
 * @ Modified by: Your name
 * @ Modified time: 2020-07-18 11:51:50
 * @ Description:
 */

import http from '@/api/base'
// 查询管理员用户列表
const findParkUsers = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/findParkUsers', params)
}
// 获取管理员用户列表
const getDepartmentManager = (params) => {
  return http.post('/portal/department/getDepartmentAllUserInfo', params)
}
const findParkUserOne = (params) => {
  // params.mockApi = true
  return http.get('/portal/park/user/findParkUserOne', {params})
}
const findUserCompanyTaffById = (params) => {
  // params.mockApi = true
  return http.get('/portal/park/user/findUserCompanyTaffById', {params})
}
const findParkUsersByNotInRoleId = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/findParkUsersByNotInRoleId', params)
}
const getWebDepartmentUserInfo = (params) => {
  // params.mockApi = true
  return http.post('/portal/department/getWebDepartmentUserInfo', params)
}

// const findUserCompanytaffById = (params) => {
//   return http.get('/portal/park/user/findUserCompanytaffById', {params})
// }

const insertParkAdminUser = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/insertParkAdminUser', params)
}
const updateParkAdminUser = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/updateParkAdminUser', params)
}

// 删除管理员用户
const deleteParkAdminUserByUserId = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/deleteParkAdminUserByUserId', params)
}

// 向角色中添加多个人员
const addUserForUserIds = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/addUserForUserIds', params)
}
// 向角色中添加多个人员
const addUserForRoleIds = (params) => {
  // params.mockApi = true
  return http.post('/portal/park/user/addUserForRoleIds', params)
}
// 更新用户启用/禁用状态
const updateEnableCPmpamyStaffById = (params) => {
  // params.mockApi = true
  return http.post('/portal/user/updateEnableCPmpamyStaffById', params)
}
// 房源相关接口
// 获取房源区域设置列表页
const getAreaSettingData = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return http.post('/portal/estate/regionList', params)
}
// 删除房源区域
const deleteRegion = (params) => {
  return http.post('/portal/estate/regionDelete', params)
}
// 区域编码和名称验证
const checkregionCodeName = (params) => {
  return http.post('/portal/estate/regionCheck', params)
}
// 根据区域id获取详细信息
const regionDetail = (params) => {
  return http.post('/portal/estate/regionDetail', params)
}
// 新增区域编码和名称
const addRegion = (params) => {
  return http.post('/portal/estate/regionAdd', params)
}
// 修改区域编码和名称
const editRegion = (params) => {
  return http.post('/portal/estate/regionUpdate', params)
}
// 获取房源楼栋设置列表页
const getBuildSettingData = (params) => {
  return http.post('/portal/estate/listBuild', params)
}
// 删除楼栋列表中的房源
const deleteBuild = (params) => {
  return http.post('/portal/estate/deleteBuild', params)
}
// 检查楼栋编码和名称是否可用
const checkBuildInfo = (params) => {
  return http.post('/portal/estate/checkBuildInfo', params)
}
// 检查房间编码和名称是否可用
const checkRoomCode = (params) => {
  return http.post('/portal/checkRoomCode', params)
}
// 获取房源房间设置列表页
const gethouseBillData = (params) => {
  return http.post('/portal/room/queryList/map', params)
}
// 获取楼栋设置中的区域下拉框列表
const getRegionName = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return http.get('/portal/estate/regionInfo', params)
}
// 获取楼栋设置中的楼栋下拉框列表
const getBuildName = (params) => {
  return http.post('/portal/estate/buildInfo', params)
}
// 获取楼栋设置中的楼层下拉框列表
const getFloorName = (params) => {
  return http.post('/portal/estate/floorInfo', params)
}
// 获取区域范围内的楼栋名称
const getAreaHouseName = (params) => {
  // params.mockApi = true
  return http.get('/portal/park/user/getAreaHouseName', {params})
}
// 获取楼栋设置查看/设置详情
const detailBuild = (params) => {
  return http.post('/portal/estate/detailBuild', params)
}
// 获取房间台账中房间详情
const getRoomInfo = (params) => {
  // params.mockApi = true
  return http.get('/portal/park/user/getRoomInfo', {params})
}
// 删除房间台账中的房间
const deleteBillRoom = (params) => {
  return http.post('/portal/room/del', params)
}
// 获取房间编号
const getDayVsersion = (params) => {
  return http.get('/portal/room/getDayVsersion', {params})
}
// 检查房间是否能合并
const isMerger = (params) => {
  return http.post('/portal/room/isMerger', params)
}
// 新增房间台账中的房间
const addBillRomm = (params) => {
  return http.post('/portal/room/add', params)
}
// 修改房间台账中的房间
const editBillRomm = (params) => {
  return http.post('/portal/room/update', params)
}
// 新增区域下的楼栋名称
const addBuildName = (params) => {
  return http.post('/portal/estate/addBuild', params)
}
// 新增区域下的楼栋名称
const updateBuild = (params) => {
  return http.post('/portal/estate/updateBuild', params)
}
// 合并房间台账中的房间
const mergeBillRomm = (params) => {
  return http.post('/portal/room/merge', params)
}
// 拆分房间台账中的房间
const splitBillRomm = (params) => {
  return http.post('/portal/room/splite', params)
}
// 获取拆分合并详情信息
const getSplitMergeRoom = (params) => {
  return http.get(`/portal/room/split-merge/${params.roomId}`)
}
// 导出房间台账表哥
const exporRoomExcel = (params) => {
  return http.post('/portal/room/exportExcel', params, { responseType: 'blob' })
}

// 导出楼栋设置列表
const exportBuildlist = (params) => {
  return http.post('/portal/estate/build/exportExcel', params, { responseType: 'blob' })
}
// 导出房间上传校验失败结果
const exportUpload = (params) => {
  return http.post(`/portal/room/exportExcelMsg`, params, { responseType: 'blob' })
}
// 导出房间上传校验失败结果
const deleteFile = (params) => {
  return http.post(`/portal/open/images/imageInfo`, params)
}

// 下载附件中的文件
const downloadAttachment = (params) => {
  return http.post(`/portal/estate/downloadAttachment`, params, { responseType: 'blob' })
}
// 查询公司部门
const departmentBook = (params) => {
  return http.post('/portal/department/departmentBook', params)
}
const getDepartmentInfo = (params) => {
  return http.get('/portal/department/findDetailById', {params})
}
// 添加公司部门
const addDepartment = (params) => {
  return http.post('/portal/department/addDepartment', params)
}
// 查询部门人员信息
const getDepartmentUserInfo = (params) => {
  return http.post('/portal/department/getDepartmentUserInfo', params)
}
// 更新员工的部门
const setStaffDepartment = (params) => {
  return http.post('/portal/department/setStaffDepartment', params)
}
// 更新部门
const updateDepartment = (params) => {
  return http.post('/portal/department/updateDepartment', params)
}

// 获取部门人
const getParkUsersByNotInRoleId = (params) => {
  return http.post('/portal/department/departmentStaffBook', params)
}

// 获取人员排序
const getDepartmentUserInfoOrderNum = (params) => {
  return http.post('/portal/department/getDepartmentUserInfoOrderNum2', params)
}
// 获取人员排序
const getOrderNumByDepartmentIdAndUserId = (params) => {
  return http.post('/portal/department/getOrderNumByDepartmentIdAndUserId', params)
}
// 获取部门排序
const getDepartmentMaxOrderNum = (params) => {
  return http.post('/portal/department/departmentMaxOrderNum', params)
}

// 设施运营公司的企业管理员
const getSuperRoleUserLsit = (params) => {
  return http.post('/portal/park/user/role/getSuperRoleUserInfo', params)
}
// 设施运营公司的企业管理员
const addSuperRoleUser = (params) => {
  return http.post('/portal/park/user/role/addSuperRoleForUserIds', params)
}
// 设施运营公司的企业管理员
const updateSuperRoleUser = (params) => {
  return http.post('/portal/park/user/role/updateSuperRoleInfo', params)
}
// 设施运营公司的企业管理员
const delSuperRoleUser = (params) => {
  return http.post('/portal/park/user/role/delSuperRoleInfo', params)
}

export default {
  findParkUsers,
  deleteParkAdminUserByUserId,
  insertParkAdminUser,
  updateParkAdminUser,
  findParkUsersByNotInRoleId,
  // findUserCompanytaffById,
  getWebDepartmentUserInfo,
  findParkUserOne,
  findUserCompanyTaffById,
  addUserForUserIds,
  addUserForRoleIds,
  getAreaSettingData,
  getBuildSettingData,
  gethouseBillData,
  getRegionName,
  getAreaHouseName,
  detailBuild,
  deleteBuild,
  getRoomInfo,
  checkBuildInfo,
  deleteBillRoom,
  addBillRomm,
  mergeBillRomm,
  splitBillRomm,
  regionDetail,
  getSplitMergeRoom,
  exporRoomExcel,
  deleteRegion,
  checkregionCodeName,
  addRegion,
  editRegion,
  exportBuildlist,
  getBuildName,
  addBuildName,
  updateBuild,
  getFloorName,
  checkRoomCode,
  exportUpload,
  editBillRomm,
  deleteFile,
  getDepartmentInfo,
  addDepartment,
  departmentBook,
  getDepartmentUserInfo,
  setStaffDepartment,
  downloadAttachment,
  updateDepartment,
  getDayVsersion,
  isMerger,
  getDepartmentManager,
  getParkUsersByNotInRoleId,
  getDepartmentUserInfoOrderNum,
  getDepartmentMaxOrderNum,
  getSuperRoleUserLsit,
  addSuperRoleUser,
  updateSuperRoleUser,
  delSuperRoleUser,
  updateEnableCPmpamyStaffById,
  getOrderNumByDepartmentIdAndUserId
}



// WEBPACK FOOTER //
// ./src/area-common/api/managerService.js